import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import LandingPage from "@/pages/LandingPage";
import CheckoutPage from "@/pages/CheckoutPage";
import PaymentStatusPage from "@/pages/PaymentStatusPage";
import BookReaderPage from "@/pages/BookReaderPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminConfigPage from "@/pages/AdminConfigPage";
import AdminOrdersPage from "@/pages/AdminOrdersPage";
import AdminContentEditorPage from "@/pages/AdminContentEditorPage";
import AdminBookContentPage from "@/pages/AdminBookContentPage";
import AdminVideosPage from "@/pages/AdminVideosPage";
import VideosPage from "@/pages/VideosPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import DyvysHomePage from "@/pages/DyvysHomePage";
import DyvysSeriesDetailPage from "@/pages/DyvysSeriesDetailPage";
import DyvysWatchPage from "@/pages/DyvysWatchPage";
import DyvysCheckoutPage from "@/pages/DyvysCheckoutPage";
import DyvysAdminLoginPage from "@/pages/DyvysAdminLoginPage";
import DyvysAdminSeriesPage from "@/pages/DyvysAdminSeriesPage";
import DyvysAdminEpisodesPage from "@/pages/DyvysAdminEpisodesPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
            <Route path="/payment/:txnId" element={<ProtectedRoute><PaymentStatusPage /></ProtectedRoute>} />
            <Route path="/read" element={<ProtectedRoute><BookReaderPage /></ProtectedRoute>} />
            <Route path="/videos" element={<ProtectedRoute><VideosPage /></ProtectedRoute>} />
            <Route path="/privacy-policy" element={<ProtectedRoute><PrivacyPolicyPage /></ProtectedRoute>} />
            <Route path="/terms" element={<ProtectedRoute><TermsPage /></ProtectedRoute>} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/editor" element={<AdminContentEditorPage />} />
            <Route path="/admin/book" element={<AdminBookContentPage />} />
            <Route path="/admin/videos" element={<AdminVideosPage />} />
            <Route path="/admin/config" element={<AdminConfigPage />} />
            <Route path="/admin/orders" element={<AdminOrdersPage />} />
            
            {/* DYVY'S Afrique Routes */}
            <Route path="/dyvys" element={<DyvysHomePage />} />
            <Route path="/dyvys/series/:seriesId" element={<DyvysSeriesDetailPage />} />
            <Route path="/dyvys/watch/:episodeId" element={<DyvysWatchPage />} />
            <Route path="/dyvys/checkout/:itemType/:itemId" element={<DyvysCheckoutPage />} />
            <Route path="/dyvys/admin/login" element={<DyvysAdminLoginPage />} />
            <Route path="/dyvys/admin/series" element={<DyvysAdminSeriesPage />} />
            <Route path="/dyvys/admin/episodes/:seriesId" element={<DyvysAdminEpisodesPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;